import React, { useState } from 'react';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import MobileSearchModal from '../../../components/base/MobileSearchModal';
import MobilePeriodModal from '../../../components/base/MobilePeriodModal';
import MobileIntervalModal from '../../../components/base/MobileIntarvalModal';

export default function MobileVehicleFooter(props) {
  const {
    control,
    page,
    defaultValues,
    defaultFilterValues = {},
    getValues = () => {},
    setValue = () => {},
    reset = () => {},
    hidePeriod = false,
    showInterval = false,
  } = props;
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [isOpenSearch, setOpenSearch] = useState(false);
  const [isOpenPeriod, setOpenPeriod] = useState(false);
  const [isOpenInterval, setOpenInterval] = useState(false);

  return (
    <div className="application-footer">
      <div className="footer-button" onClick={() => setOpenSearch(true)}>
        <div className="footer-button-icon">
          <Icons customIcon icon="search" />
        </div>
        <div className="footer-button-text">Поиск</div>
      </div>
      <div className="footer-button" onClick={() => setOpenFilter(true)}>
        <div className="footer-button-icon">
          <Icons customIcon icon="filter" />
        </div>
        <div className="footer-button-text">Фильтр</div>
      </div>
      {!hidePeriod ? (
        <div className="footer-button" onClick={() => setOpenPeriod(true)}>
          <div className="footer-button-icon">
            <Icons customIcon icon="calendar" />
          </div>
          <div className="footer-button-text">Период</div>
        </div>
      ) : null}
      {showInterval ? (
        <div className="footer-button" onClick={() => setOpenInterval(true)}>
          <div className="footer-button-icon">
            <Icons customIcon icon="calendar" />
          </div>
          <div className="footer-button-text">Период</div>
        </div>
      ) : null}
      {isOpenFilter
        ? (
          <FilterModal
            control={control}
            onClose={() => setOpenFilter(false)}
            getValues={getValues}
            reset={reset}
            defaultValues={defaultFilterValues}
            page={page}
          />
        )
        : null}
      {isOpenSearch
        ? (
          <MobileSearchModal
            control={control}
            defaultValues={defaultValues}
            reset={reset}
            getValues={getValues}
            handleClose={() => setOpenSearch(false)}
          />
        )
        : null}
      {isOpenPeriod
        ? (
          <MobilePeriodModal
            control={control}
            defaultValues={defaultValues}
            reset={reset}
            getValues={getValues}
            handleClose={() => setOpenPeriod(false)}
          />
        )
        : null}
      {isOpenInterval
        ? (
          <MobileIntervalModal
            control={control}
            defaultValues={defaultValues}
            reset={reset}
            getValues={getValues}
            setValue={setValue}
            handleClose={() => setOpenInterval(false)}
          />
        )
        : null}
    </div>
  );
}
